// extracted by mini-css-extract-plugin
export default {"column":"PodcastsPage_column__1rOQZ","episodeRow":"PodcastsPage_episodeRow__-t8J7"};